module.exports = __webpack_public_path__ + "media/honey-icons/icon-menu-246caa14.svg";